import tabbyLogo from "@/assets/logos/tabby-logo.png";
import tamaraLogo from "@/assets/logos/tamara-logo.png";
import cashewLogo from "@/assets/logos/cashew-logo.png";

const PROVIDERS = [
  { name: "Tabby", logo: tabbyLogo },
  { name: "Tamara", logo: tamaraLogo },
  { name: "Cashew", logo: cashewLogo },
];

export default function ProviderLogoPills() {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {PROVIDERS.map((p) => (
        <span
          key={p.name}
          className="inline-flex items-center rounded-full bg-[hsl(36_39%_93%)] px-2 py-0.5"
        >
          <img src={p.logo} alt={p.name} className="h-5 w-auto object-contain" />
        </span>
      ))}
    </div>
  );
}
